import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import axios from "axios";
import config from "../../../config";
import Swal from "sweetalert2";

function BulkUpload(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [shownew, setShownew] = useState(false);
  const [errors, setError] = useState("");
  const [uploadedFile, setUploadedFile] = useState();
  const [fileError, setFileError] = useState([]);
  const [excelLoader, setExcelLoader] = useState(false);
  const [apiError, setApiError] = useState();
  const [downloadLoader, setdownloadLoader] = useState(false);

  const [initialValues1, setInitialValues] = useState({
    upload_excel: "",
    file_type: "1", // Default to "Add Supplier"
  });
  let loginToken = JSON.parse(localStorage.getItem("inventory"))?.token ?? "";

  const headers = {
    headers: {
      Authorization: `Bearer ${loginToken}`,
    },
  };

  const downloadSample = async () => {
    if (initialValues1.file_type === "") {
      setApiError("Please select File Type");
      setTimeout(() => {
        setApiError("");
      }, 3000);
    } else {
      try {
        setdownloadLoader(true);
        const payload = {
          excel_type: initialValues1.file_type,
        };
        const { data } = await axios.post(
          `${config.apiUrl}/buyer/buyerTemplate`,
          payload,
          {
            ...headers,
            timeout: 600000,
          },
        );
        const fileResponse = await fetch(data.data.excel_url);
        const blob = await fileResponse.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "supplier.xlsx";
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setExcelLoader(false);
        setdownloadLoader(false);
      } catch (error) {
        setdownloadLoader(false);
        setApiError(
          error.response?.data?.data?.message ||
            error.response?.data?.message ||
            "Something went wrong",
        );
        setTimeout(() => {
          setApiError("");
        }, 3000);
      }
    }
  };

  const uploadExcel = async () => {
    if (initialValues1.file_type === "" || initialValues1.upload_excel === "") {
      setApiError("Please fill all the data properly");
      setTimeout(() => {
        setApiError("");
      }, 3000);
    } else {
      setExcelLoader(true);
      const formData = new FormData();
      formData.append("excel", initialValues1.upload_excel);
      formData.append("excel_type", initialValues1.file_type);
      try {
        const { data } = await axios.post(
          `${config.apiUrl}/buyer/buyerAddBulk`,
          formData,
          {
            ...headers,
            timeout: 600000,
          },
        );
        const response = await axios.get(data.data.excel_url, {
          responseType: "blob",
          timeout: 600000,
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "supplier_import_result.xlsx";
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        setExcelLoader(false);
        setdownloadLoader(false);

        props.hide();
        setInitialValues({
          upload_excel: "",
          file_type: "1",
        });
        props.list();
      } catch (error) {
        setExcelLoader(false);
        setApiError(
          error.response?.data?.data?.message ||
            error.response?.data?.message ||
            "Something went wrong",
        );
        setTimeout(() => {
          setApiError("");
        }, 3000);
      }
    }
  };

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          Upload Excel
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row">
          <div className="col-md-12 ">
            <label
              style={{ fontSize: "14px", fontWeight: "300", marginTop: "14px" }}
              htmlFor="upload_excel"
            >
              Upload Excel <span className="text-danger"> *</span>
            </label>

            <FormControl
              type="file"
              accept=".csv, .xls, .xlsx"
              onChange={(event) => {
                const selectedFile = event.target.files[0];

                if (selectedFile.size > 5000000) {
                  // 5MB
                  setApiError("File size must be less than 5MB");
                  setTimeout(() => {
                    setApiError("");
                  }, 3000);
                  event.target.value = "";
                  return;
                }
                if (
                  event?.target?.files[0]?.type.includes(
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  ) ||
                  event?.target?.files[0]?.type.includes(
                    "application/vnd.ms-excel",
                  ) ||
                  event?.target?.files[0]?.name.endsWith(".csv")
                ) {
                  setInitialValues({
                    ...initialValues1,
                    upload_excel: selectedFile,
                  });
                  setUploadedFile(selectedFile);
                  setFileError({
                    ...fileError,
                    upload_excel: "",
                  });
                } else {
                  setFileError({
                    ...fileError,
                    upload_excel: "Please upload (Excel,csv) Only",
                  });
                }
              }}
              autoComplete="off"
              className="form-control"
              id="upload_excel"
              name="upload_excel"
            />
            {fileError && fileError.upload_excel && (
              <div className="text-danger small text-start">
                {fileError.upload_excel}
              </div>
            )}
          </div>
        </div>
        <div className="row gy-3 mt-2 mb-1">
          <div className="col-12 mt-4">
            <button
              className="branchModalCancel"
              onClick={(e) => {
                props.hide();
                setInitialValues({
                  upload_excel: "",
                  file_type: "1",
                });
              }}
              style={{ float: "right" }}
            >
              Cancel
            </button>
            <button
              id="createNew"
              onClick={() => {
                uploadExcel();
              }}
            >
              {excelLoader && (
                <span className="spinner-border spinner-border-sm me-2"></span>
              )}
              Submit
            </button>
          </div>
        </div>

        <div className=" text-center">
          <a
            onClick={downloadSample}
            style={{
              cursor: "pointer",
            }}
            className="text-decoration-underline text-primary"
          >
            {downloadLoader && (
              <span className="spinner-border spinner-border-sm me-2"></span>
            )}
            <span>Download Sample File</span>
          </a>
        </div>

        {apiError ? (
          <div className="alert alert-danger py-1 small mt-2" role="alert">
            {apiError}
          </div>
        ) : null}
      </div>
    </>
  );
}

export default BulkUpload;
